import {
  Component,
  ContentChild,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { ToolbarChartsSectionComponent } from '../apt-toolbar/toolbar-charts-section/toolbar-charts-section.component';
import { ToolbarFilterSectionComponent } from '../apt-toolbar/toolbar-filter-section/toolbar-filter-section.component';
import { ToolbarOptionsSectionComponent } from '../apt-toolbar/toolbar-options-section/toolbar-options-section.component';
import { ToolbarPageLayoutService } from './toolbar-page-layout.service';
import { ToolbarHeaderSectionComponent } from '../apt-toolbar/toolbar-header-section/toolbar-header-section.component';

@Component({
    selector: 'app-toolbar-page-layout',
    templateUrl: './toolbar-page-layout.component.html',
    styleUrls: ['./toolbar-page-layout.component.scss'],
    providers: [ToolbarPageLayoutService],
    standalone: false
})
export class ToolbarPageLayoutComponent implements OnInit {
  @HostBinding('class') classes = 'flex-column container-fluid overflow-auto';

  @Input()
  defaultFiltersButtonValue = false;
  @Input()
  defaultChartsButtonValue = false;
  @Input()
  defaultOptionsButtonValue = false;

  @Input()
  defaultPageHeaderValue = false;

  @Input()
  optionsPosition: 'side' | 'top' = 'side';

  @Input()
  set disableOptionsButton(disable: boolean) {
    if (disable) {
      this.toolbarPageLayoutService.setOptionsVisibility(false);
    }
    this.toolbarPageLayoutService.setDisableOptions(disable);
  }

  constructor(public toolbarPageLayoutService: ToolbarPageLayoutService) {}

  @ContentChild(ToolbarOptionsSectionComponent)
  set optionsSection(
    optionsSection: ToolbarOptionsSectionComponent | undefined,
  ) {
    this.toolbarPageLayoutService.setOptionsButtonVisibility(!!optionsSection);
  }

  @ContentChild(ToolbarFilterSectionComponent)
  set filterSection(filterSection: ToolbarFilterSectionComponent | undefined) {
    this.toolbarPageLayoutService.setFilterButtonVisibility(!!filterSection);
  }

  @ContentChild(ToolbarHeaderSectionComponent)
  set headerSection(headerSection: ToolbarHeaderSectionComponent | undefined) {
    this.toolbarPageLayoutService.setHeaderVisibility(!!headerSection);
  }
  @ContentChild(ToolbarChartsSectionComponent)
  set chartsSection(chartsSection: ToolbarChartsSectionComponent | undefined) {
    this.toolbarPageLayoutService.setChartsButtonVisibility(!!chartsSection);
  }

  ngOnInit(): void {
    if (this.defaultFiltersButtonValue) {
      this.toolbarPageLayoutService.toggleShowFilters();
    }
    if (this.defaultChartsButtonValue) {
      this.toolbarPageLayoutService.toggleShowCharts();
    }
    if (this.defaultOptionsButtonValue) {
      this.toolbarPageLayoutService.toggleShowOptions();
    }
    if (this.defaultPageHeaderValue) {
      this.toolbarPageLayoutService.toggleShowPageHeader();
    }
  }
}
